// ── Book-name → abbr lookup for cross-reference parsing ──────────────────────
export const REF_NAME_MAP = {
  // OT
  'genesis':'Gen','gen':'Gen',
  'exodus':'Exo','exod':'Exo','exo':'Exo','ex':'Exo',
  'leviticus':'Lev','lev':'Lev',
  'numbers':'Num','num':'Num',
  'deuteronomy':'Deut','deut':'Deut','deu':'Deut',
  'joshua':'Josh','josh':'Josh','jos':'Josh',
  'judges':'Judg','judg':'Judg','jud':'Judg',
  'ruth':'Ruth',
  '1 samuel':'1Sam','1 sam':'1Sam','1sam':'1Sam',
  '2 samuel':'2Sam','2 sam':'2Sam','2sam':'2Sam',
  '1 kings':'1Kgs','1 kgs':'1Kgs','1 king':'1Kgs','1 kgs':'1Kgs',
  '2 kings':'2Kgs','2 kgs':'2Kgs','2 king':'2Kgs',
  '1 chronicles':'1Chr','1 chron':'1Chr','1 chr':'1Chr','1chr':'1Chr',
  '2 chronicles':'2Chr','2 chron':'2Chr','2 chr':'2Chr','2chr':'2Chr',
  'ezra':'Ezra',
  'nehemiah':'Neh','neh':'Neh',
  'esther':'Esth','esth':'Esth',
  'job':'Job',
  'psalms':'Ps','psalm':'Ps','ps':'Ps','psa':'Ps',
  'proverbs':'Prov','prov':'Prov',
  'ecclesiastes':'Eccl','eccl':'Eccl','eccles':'Eccl',
  'song':'Song','song of songs':'Song','song of solomon':'Song','ss':'Song','s.s':'Song',
  'isaiah':'Isa','isa':'Isa',
  'jeremiah':'Jer','jer':'Jer',
  'lamentations':'Lam','lam':'Lam',
  'ezekiel':'Ezek','ezek':'Ezek','eze':'Ezek',
  'daniel':'Dan','dan':'Dan',
  'hosea':'Hos','hos':'Hos',
  'joel':'Joel',
  'amos':'Amos',
  'obadiah':'Obad','obad':'Obad',
  'jonah':'Jonah',
  'micah':'Mic','mic':'Mic',
  'nahum':'Nah','nah':'Nah',
  'habakkuk':'Hab','hab':'Hab',
  'zephaniah':'Zeph','zeph':'Zeph',
  'haggai':'Hag','hag':'Hag',
  'zechariah':'Zech','zech':'Zech','zec':'Zech',
  'malachi':'Mal','mal':'Mal',
  // NT
  'matthew':'Mt','matt':'Mt','mat':'Mt','mt':'Mt',
  'mark':'Mk','mk':'Mk','mar':'Mk',
  'luke':'Lk','lk':'Lk',
  'john':'Jn','jn':'Jn','joh':'Jn',
  'acts':'Acts','act':'Acts',
  'romans':'Rm','rom':'Rm',
  '1 corinthians':'1Co','1 cor':'1Co','1cor':'1Co',
  '2 corinthians':'2Co','2 cor':'2Co','2cor':'2Co',
  'galatians':'Gal','gal':'Gal',
  'ephesians':'Eph','eph':'Eph',
  'philippians':'Phil','phil':'Phil',
  'colossians':'Col','col':'Col',
  '1 thessalonians':'1Th','1 thess':'1Th','1 thes':'1Th','1thess':'1Th',
  '2 thessalonians':'2Th','2 thess':'2Th','2 thes':'2Th','2thess':'2Th',
  '1 timothy':'1Ti','1 tim':'1Ti','1tim':'1Ti',
  '2 timothy':'2Ti','2 tim':'2Ti','2tim':'2Ti',
  'titus':'Tit','tit':'Tit',
  'philemon':'Phm','phlm':'Phm','phm':'Phm',
  'hebrews':'Heb','heb':'Heb',
  'james':'Jas','jas':'Jas',
  '1 peter':'1Pe','1 pet':'1Pe','1pet':'1Pe',
  '2 peter':'2Pe','2 pet':'2Pe','2pet':'2Pe',
  '1 john':'1Jn','1 joh':'1Jn','1jn':'1Jn',
  '2 john':'2Jn','2 joh':'2Jn','2jn':'2Jn',
  '3 john':'3Jn','3 joh':'3Jn','3jn':'3Jn',
  'jude':'Jude',
  'revelation':'Rev','rev':'Rev',
};

// ── Chinese book abbreviation → our book_abbr ────────────────────────────────
// Includes BOTH Simplified Chinese (SC) and Traditional Chinese (TW) variants
// so cross-refs work whether the popup content is SC or TW.
// Multi-char keys MUST come before single-char ones (greedy matching order).
export const ZH_BOOK_MAP = {
  // NT multi-char — SC forms (后) + TW forms (後)
  '林前':'1Co',
  '林后':'2Co','林後':'2Co',
  '帖前':'1Th',
  '帖后':'2Th','帖後':'2Th',
  '提前':'1Ti',
  '提后':'2Ti','提後':'2Ti',
  '彼前':'1Pe',
  '彼后':'2Pe','彼後':'2Pe',
  // 1/2/3 John — SC (约) and TW (約)
  '约一':'1Jn','約一':'1Jn',
  '约二':'2Jn','約二':'2Jn',
  '约三':'3Jn','約三':'3Jn',
  // OT multi-char (same in SC and TW)
  '撒上':'1Sam','撒下':'2Sam',
  '王上':'1Kgs','王下':'2Kgs',
  '代上':'1Chr','代下':'2Chr',
  // NT single-char — SC + TW variants where chars differ
  '太':'Mt','可':'Mk','路':'Lk',
  '约':'Jn','約':'Jn',           // SC: 约  TW: 約
  '徒':'Acts',
  '罗':'Rm','羅':'Rm',           // SC: 罗  TW: 羅
  '加':'Gal','弗':'Eph','腓':'Phil','西':'Col',
  '多':'Tit',
  '门':'Phm','門':'Phm',         // SC: 门  TW: 門
  '来':'Heb','來':'Heb',         // SC: 来  TW: 來
  '雅':'Jas',
  '犹':'Jude','猶':'Jude',       // SC: 犹  TW: 猶
  '启':'Rev','啟':'Rev',         // SC: 启  TW: 啟
  // OT single-char — SC + TW variants
  '创':'Gen','創':'Gen',         // SC: 创  TW: 創
  '出':'Exo','利':'Lev','民':'Num','申':'Deut',
  '书':'Josh','書':'Josh',       // SC: 书  TW: 書
  '士':'Judg','得':'Ruth','拉':'Ezra','尼':'Neh',
  '斯':'Esth','伯':'Job',
  '诗':'Ps','詩':'Ps',           // SC: 诗  TW: 詩
  '箴':'Prov',
  '传':'Eccl','傳':'Eccl',       // SC: 传  TW: 傳
  '歌':'Song',
  '赛':'Isa','賽':'Isa',         // SC: 赛  TW: 賽
  '耶':'Jer','哀':'Lam',
  '结':'Ezek','結':'Ezek',       // SC: 结  TW: 結
  '但':'Dan',
  '何':'Hos','珥':'Joel','摩':'Amos','俄':'Obad','拿':'Jonah',
  '弥':'Mic','彌':'Mic',         // SC: 弥  TW: 彌
  '鸿':'Nah','鴻':'Nah',         // SC: 鸿  TW: 鴻
  '哈':'Hab','番':'Zeph',
  '该':'Hag','該':'Hag',         // SC: 该  TW: 該
  '亚':'Zech','亞':'Zech',       // SC: 亚  TW: 亞
  '玛':'Mal','瑪':'Mal',         // SC: 玛  TW: 瑪
};
// Book abbr keys sorted longest-first for greedy matching
const _sortedZhKeys = Object.keys(ZH_BOOK_MAP).sort((a, b) => b.length - a.length);

// Chinese chapter numeral regex (covers chapters 1-150)
// Includes BOTH standard form (二十八=28, 十三=13) AND compact two-digit form (二八=28, 四五=45)
const ZH_CH_PAT =
  '(?:一百(?:[一二三四五]十[一二三四五六七八九]?|零[一二三四五六七八九])?' +
  '|[二三四五六七八九]十[一二三四五六七八九]?' +
  '|十[一二三四五六七八九]?' +
  '|[一二三四五六七八九][一二三四五六七八九]' +  // compact 2-digit: 四五=45, 二八=28
  '|[一二三四五六七八九])';

// Pre-compiled anchored regexes for ZH chapter matching
const _zhChRe     = new RegExp('^(' + ZH_CH_PAT + ')(\\d+)(?:[上中下])?(?:[–\\-～](\\d+))?');
const _zhArabicRe = /^(\d+):(\d+)(?:[–\-～](\d+))?/;

// Convert a Chinese chapter numeral string to an integer
export function parseZhChapter(s) {
  const D = {一:1,二:2,三:3,四:4,五:5,六:6,七:7,八:8,九:9};
  if (D[s] !== undefined) return D[s];
  if (s === '十') return 10;
  // Compact two-digit form: 四五=45, 二八=28, 一六=16, etc. (no 十 present)
  if (s.length === 2 && D[s[0]] !== undefined && D[s[1]] !== undefined) {
    return D[s[0]] * 10 + D[s[1]];
  }
  if (s.startsWith('一百')) {
    const r = s.slice(2);
    if (!r) return 100;
    if (r[0] === '零') return 100 + (D[r[1]] || 0);
    const shi = r.indexOf('十');
    if (shi !== -1) return 100 + (D[r[shi - 1]] || 0) * 10 + (D[r[shi + 1]] || 0);
    return 100;
  }
  const shi = s.indexOf('十');
  if (shi !== -1) {
    const tens = shi === 0 ? 1 : (D[s[0]] || 0);
    return tens * 10 + (D[s[shi + 1]] || 0);
  }
  return 0;
}

// ── Parse ZH ref strings — handles both BB2 Arabic (太1:16) and
//   footnote Chinese-numeral (弗一10；三9) formats, with continuation ──────────
export function parseZhRefTokens(content) {
  const tokens = [];
  let lastIdx = 0;
  let lastAbbr = null;
  let i = 0;

  while (i < content.length) {
    let matched = false;

    // 1. Try book abbr (longest-first) + chapter at position i
    for (const key of _sortedZhKeys) {
      if (content.startsWith(key, i)) {
        const pos  = i + key.length;
        const abbr = ZH_BOOK_MAP[key];
        const rest = content.slice(pos);

        // Try Arabic ch:v  (e.g. 太1:16)
        const ara = rest.match(_zhArabicRe);
        if (ara) {
          if (i > lastIdx) tokens.push({ type: 'text', text: content.slice(lastIdx, i) });
          lastAbbr = abbr;
          tokens.push({ type: 'ref', label: key + ara[0], abbr,
            chapter: parseInt(ara[1]), startVerse: parseInt(ara[2]),
            endVerse: ara[3] ? parseInt(ara[3]) : parseInt(ara[2]) });
          lastIdx = i = pos + ara[0].length;
          matched = true;
          break;
        }
        // Try Chinese ch + Arabic verse  (e.g. 弗一10)
        const zh = rest.match(_zhChRe);
        if (zh) {
          if (i > lastIdx) tokens.push({ type: 'text', text: content.slice(lastIdx, i) });
          lastAbbr = abbr;
          tokens.push({ type: 'ref', label: key + zh[0], abbr,
            chapter: parseZhChapter(zh[1]), startVerse: parseInt(zh[2]),
            endVerse: zh[3] ? parseInt(zh[3]) : parseInt(zh[2]) });
          lastIdx = i = pos + zh[0].length;
          matched = true;
          break;
        }
        break; // book abbr found but no chapter — don't try shorter keys
      }
    }

    // 2. Try bare continuation (no book prefix) when a previous book is known
    if (!matched && lastAbbr) {
      const rest = content.slice(i);
      // Arabic ch:v continuation (e.g. 3:9 after Col.)
      const ara = rest.match(_zhArabicRe);
      if (ara) {
        if (i > lastIdx) tokens.push({ type: 'text', text: content.slice(lastIdx, i) });
        tokens.push({ type: 'ref', label: ara[0], abbr: lastAbbr,
          chapter: parseInt(ara[1]), startVerse: parseInt(ara[2]),
          endVerse: ara[3] ? parseInt(ara[3]) : parseInt(ara[2]) });
        lastIdx = i = i + ara[0].length;
        matched = true;
      } else {
        // Chinese ch continuation only after a ref-separator char (，；,(  etc.)
        const prevChar = i > 0 ? content[i - 1] : '';
        if (/[，；,;\s（(]/.test(prevChar)) {
          const zh = rest.match(_zhChRe);
          if (zh) {
            if (i > lastIdx) tokens.push({ type: 'text', text: content.slice(lastIdx, i) });
            tokens.push({ type: 'ref', label: zh[0], abbr: lastAbbr,
              chapter: parseZhChapter(zh[1]), startVerse: parseInt(zh[2]),
              endVerse: zh[3] ? parseInt(zh[3]) : parseInt(zh[2]) });
            lastIdx = i = i + zh[0].length;
            matched = true;
          }
        }
      }
    }

    if (!matched) i++;
  }

  if (lastIdx < content.length) tokens.push({ type: 'text', text: content.slice(lastIdx) });
  return tokens;
}

// Detect if content is Chinese (CJK characters present)
export const CJK_RE_DETECT = /[一-鿿㐀-䶿]/;

// ── Parse a cross-ref string into text + ref tokens ──────────────────────────
// contextBook / contextChapter: the book+chapter whose note we're reading.
//   • lastAbbr/lastChapter reset to context at each newline (paragraph boundary)
//   • Alt 3: bare verse after "," or ";" inherits lastAbbr + lastChapter
//   • Alt 4: "v. N" / "vv. N-M" links to contextBook + contextChapter + verse
export function parseRefTokens(content, contextBook = null, contextChapter = null) {
  // Pass 1: strip digit+letter note markers appended to verse numbers
  //   "2 Cor. 13:141a" (verse 14 + marker "1a") → "2 Cor. 13:14"
  let cleaned = content.replace(/:(\d+)\d[a-z]+/gi, ':$1');

  // Pass 2: mark single-digit note numbers that follow "note Book ch:v"
  //   "note Job 38:71" (verse 7 + note marker 1) → "note Job 38:7\x001"
  cleaned = cleaned.replace(
    /(\bnote\s+(?:\d+\s+)?[A-Z][A-Za-z.]+\s+\d+:)(\d+)(\d)(?=[^0-9a-zA-Z]|$)/g,
    '$1$2\x00$3'
  );

  // Alt 1: [N ] BookName ch:v[-endV]              — explicit book ref
  // Alt 2: ch:v[-endV]                             — inherits lastAbbr
  // Alt 3: bare verse after "," or ";" with spaces — inherits lastAbbr + lastChapter
  // Alt 4: v. N / vv. N[-M]                        — uses contextBook + contextChapter
  const re = /(?:(\d+)\s+)?([A-Z][A-Za-z]*(?:\.[A-Za-z]+)*\.?)\s+(\d+):(\d+)(?:\s*[-–]\s*(\d+))?|(?<!\d)(\d+):(\d+)(?:\s*[-–]\s*(\d+))?(?!\d)|(?<=[,;]\s{0,5})(\d{1,3})(?!\s*:)(?!\d)|\b[Vv][Vv]?\.?\s+(\d{1,3})(?:\s*[-–]\s*(\d{1,3}))?/g;

  const tokens = [];
  let lastIdx = 0;
  let lastAbbr = contextBook;
  let lastChapter = contextChapter;
  let m;

  // Push a text token, stripping any stray \x00 separators
  const pushText = (s) => { if (s) tokens.push({ type: 'text', text: s.replace(/\x00./g, '') }); };

  while ((m = re.exec(cleaned))) {
    const matchEnd = m.index + m[0].length;

    // ── Paragraph boundary check ──────────────────────────────────────────
    // If there's a newline between the last processed position and this match,
    // reset context back to the host book/chapter so "1:1" in a new paragraph
    // refers to the current book, not whatever was last cited.
    if (cleaned.slice(lastIdx, m.index).includes('\n')) {
      lastAbbr    = contextBook;
      lastChapter = contextChapter;
    }

    // After the match check for a \x00+digit note-number marker
    const noteNum  = cleaned[matchEnd] === '\x00' ? cleaned[matchEnd + 1] : null;
    const afterEnd = noteNum ? matchEnd + 2 : matchEnd;

    if (m[2] !== undefined) {
      // ── Alt 1: explicit book ref ──────────────────────────────────────
      pushText(cleaned.slice(lastIdx, m.index));
      const numPrefix = m[1] ? m[1] + ' ' : '';
      const bookRaw   = (numPrefix + m[2]).toLowerCase().replace(/\.+$/, '').trim();
      const abbr      = REF_NAME_MAP[bookRaw];
      if (abbr) {
        lastAbbr    = abbr;
        lastChapter = parseInt(m[3], 10);
        tokens.push({ type: 'ref', label: m[0], abbr, noteNum,
          chapter: lastChapter, startVerse: parseInt(m[4], 10),
          endVerse: m[5] ? parseInt(m[5], 10) : parseInt(m[4], 10) });
      } else {
        pushText(m[0]);
      }
      lastIdx = afterEnd;

    } else if (m[6] !== undefined) {
      // ── Alt 2: bare ch:v — inherits lastAbbr ─────────────────────────
      if (lastAbbr) {
        pushText(cleaned.slice(lastIdx, m.index));
        lastChapter = parseInt(m[6], 10);
        tokens.push({ type: 'ref', label: m[0], abbr: lastAbbr, noteNum,
          chapter: lastChapter, startVerse: parseInt(m[7], 10),
          endVerse: m[8] ? parseInt(m[8], 10) : parseInt(m[7], 10) });
        lastIdx = afterEnd;
      }

    } else if (m[9] !== undefined) {
      // ── Alt 3: bare verse after "," or ";" — inherits lastAbbr + lastChapter
      if (lastAbbr && lastChapter) {
        pushText(cleaned.slice(lastIdx, m.index));
        const v = parseInt(m[9], 10);
        tokens.push({ type: 'ref', label: m[9], abbr: lastAbbr, noteNum,
          chapter: lastChapter, startVerse: v, endVerse: v });
        lastIdx = afterEnd;
      }

    } else if (m[10] !== undefined) {
      // ── Alt 4: "v. N" / "vv. N-M" — uses contextBook + contextChapter ─
      if (contextBook && contextChapter) {
        pushText(cleaned.slice(lastIdx, m.index));
        const startV = parseInt(m[10], 10);
        const endV   = m[11] ? parseInt(m[11], 10) : startV;
        tokens.push({ type: 'ref', label: m[0], abbr: contextBook, noteNum,
          chapter: contextChapter, startVerse: startV, endVerse: endV });
        lastIdx = afterEnd;
      }
    }
    // unrecognised bare ch:v with no prior book → skip
  }
  pushText(cleaned.slice(lastIdx));
  return tokens;
}
